import { version as t } from "../../version.js";
import { getConsoleStyle as i } from "./styledLogs.js";
const r = "https://uikit.developers.rio.cloud/versionsList.json", a = async () => {
  const s = (e) => console.log("%c%s", i(), e);
  try {
    const e = await fetch(r), { latest_release: o } = await e.json();
    o > t && s(
      `🆕 You are using version ${t} of the UIKIT while the latest released version is ${o}. Please consider updating asap.`
    );
  } catch {
    s("Failed to fetch UIKIT version list.");
  }
};
export {
  a as checkForReleaseVersion
};
//# sourceMappingURL=checkForReleaseVersion.js.map
